import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";

const CustomModal = ({
  show,
  hideModal,
  modalTitle,
  children,
  actionSubmitModal,
  classValue,
  size,
  backdrop = "static",
  centered = false,
  footerContent = true,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={hideModal}
      size={size}
      animation={true}
      backdrop={`static`}
      keyboard={false}
      className={classValue}
      centered={centered}
      aria-labelledby="example-modal-sizes-title-sm"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div dangerouslySetInnerHTML={{ __html: modalTitle }} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footerContent && (
        <Modal.Footer>
          {actionSubmitModal && (
            <Button variant="success" onClick={actionSubmitModal}>
              {t("button.submit")}
            </Button>
          )}
          <Button variant="danger" onClick={hideModal}>
            {t("button.cancel")}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
